import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

import moment from 'moment';
export var getFormat = function getFormat(format, locale) {
  return format || moment.localeData(locale).longDateFormat('LL') || 'MMMM D, yyyy';
};
export var getFromFormat = function getFromFormat(date) {
  return moment(date).startOf('day').toISOString();
};
export var getToFormat = function getToFormat(date) {
  return moment(date).endOf('day').toISOString();
};
export var convertToDate = function convertToDate(date) {
  return moment.isMoment(date) ? date.toDate() : date;
};
export var convertToMoment = function convertToMoment(date) {
  return date ? moment.isMoment(date) ? date : moment(date) : null;
};
export var getDateRange = function getDateRange(dateValue, dateRange, isoWeek) {
  var date = {
    from: moment(),
    to: moment()
  };
  switch (dateValue) {
    case 1:
      break;
    case 2:
      {
        date = {
          from: date.from.subtract(1, 'day'),
          to: date.to.subtract(1, 'day')
        };
        break;
      }
    case 3:
      {
        date = {
          from: isoWeek ? date.from.subtract(1, 'week').startOf('isoWeek') : date.from.subtract(1, 'week').startOf('week'),
          to: isoWeek ? date.to.subtract(1, 'week').endOf('isoWeek') : date.to.subtract(1, 'week').endOf('week')
        };
        break;
      }
    case 4:
      {
        date = {
          from: date.from.subtract(1, 'month').startOf('month'),
          to: date.to.subtract(1, 'month').endOf('month')
        };
        break;
      }
    case 5:
      {
        date = {
          from: date.from.subtract(1, 'year').startOf('year'),
          to: date.to.subtract(1, 'year').endOf('year')
        };
        break;
      }
    case 6:
      {
        date = {
          from: moment(dateRange === null || dateRange === void 0 ? void 0 : dateRange[0]),
          to: moment(dateRange === null || dateRange === void 0 ? void 0 : dateRange[0])
        };
        break;
      }
    case 7:
      {
        date = {
          from: moment(dateRange === null || dateRange === void 0 ? void 0 : dateRange[0]),
          to: moment(dateRange === null || dateRange === void 0 ? void 0 : dateRange[1])
        };
        break;
      }
    default:
      return {
        from: getFromFormat(moment('01/01/1970', 'MM/DD/YYYY')),
        to: getToFormat(date.to)
      };
  }
  return {
    from: getFromFormat(date.from),
    to: getToFormat(date.to)
  };
};
var shiftKeyPressed = false;
export var onKeyUp = function onKeyUp(e) {
  if (e.key === 'Shift') {
    shiftKeyPressed = false;
  }
};

/**
 * If focused element is the last active element in the calendar view, it should return to input
 */
export var focusToPointedElement = function focusToPointedElement(calendarSelector, inputSelector, extraClass) {
  return function (e) {
    if (e.key === 'Shift') {
      shiftKeyPressed = true;
    } else if (!shiftKeyPressed && e.key === 'Tab') {
      try {
        var _document$activeEleme;
        var calendarViewElems = document.querySelectorAll("".concat(calendarSelector, " *[tabindex=\"0\"]"));
        if (document.activeElement === calendarViewElems[calendarViewElems.length - 1] || extraClass && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.classList.contains(extraClass)) {
          e.preventDefault();
          e.stopPropagation();
          var inputElement = document.querySelector(inputSelector);
          if (inputElement) {
            inputElement.focus();
          }
        }
      } catch (e) {
        throw Error('can not find the active element');
      }
    }
  };
};
export var getTabbableElements = function getTabbableElements(containerSelector) {
  var container = document.querySelector(containerSelector);
  if (container) {
    var tabbableElements = container.querySelectorAll('input, button:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])');
    var filteredElements = Array.from(tabbableElements).filter(function (_element) {
      var element = _element;
      var computedStyle = getComputedStyle(element);
      return computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden' && element.offsetParent !== null;
    });
    return filteredElements;
  }
  return [];
};
export var handleTabKey = function handleTabKey(containerSelectorArray, onExit) {
  return function (event) {
    var tabKey = 'Tab';
    if (event.key === tabKey) {
      var selectorArray = [];
      containerSelectorArray.map(function (selector) {
        var selectors = getTabbableElements(selector) || [];
        selectorArray = [].concat(_toConsumableArray(selectorArray), _toConsumableArray(selectors));
      });
      var activeElement = document.activeElement;
      var focusableElements = selectorArray;
      if (activeElement) {
        var currentFocusedIndex = focusableElements.indexOf(activeElement);
        if (event.shiftKey) {
          if (currentFocusedIndex === 0) {
            onExit === null || onExit === void 0 || onExit(event);
            return;
          }
          // Move focus to the previous element
          var previousElement = focusableElements[currentFocusedIndex - 1] || focusableElements[focusableElements.length - 1];
          previousElement.focus();
          event.preventDefault();
        } else {
          // if currentFocusedIndex === -1, it means focus on the day box, just need to follow the document rule
          if (currentFocusedIndex !== -1) {
            // Move focus to the next element
            var nextElement = focusableElements[currentFocusedIndex + 1] || focusableElements[0];
            nextElement.focus();
            event.preventDefault();
          }
        }
      }
    }
  };
};
export var focusToFirstActiveElement = function focusToFirstActiveElement(containerSelector) {
  var tabbableElements = getTabbableElements(containerSelector);
  if (tabbableElements !== null && tabbableElements !== void 0 && tabbableElements.length) {
    tabbableElements[0].focus();
  }
};
export var dateAdapter = function dateAdapter(date, disableFutrue, disablePast) {
  if (!date || !(date !== null && date !== void 0 && date.isValid())) {
    return null;
  }
  var today = moment();
  if (disableFutrue && date.isAfter(today)) {
    return null;
  }
  if (disablePast && date.startOf('day').isBefore(today.startOf('day'))) {
    return null;
  }
  return date;
};